<template>
  <div>
    月度统计：<el-select v-model="value" placeholder="请选择月份" size="mini" @change="changeMonth">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
  <div id="month" class="about" style="width:100%;height:320px"></div>
  <el-row :gutter="50" type="flex" justify="center" align="middle" style="margin: 20px 0px 0px 0px">
    <el-col :span="8">
      <div class="box"><div class="countStyle">{{amount}}</div>不含税金额</div>
    </el-col>
    <el-col :span="7">
      <div class="box"><div class="countStyle">{{tax}}</div>税额</div>
    </el-col>
    <el-col :span="9">
      <div class="box"><div class="countStyle">{{count}}</div>已开发票</div>
    </el-col>
  </el-row>
</template>

<script type="text/javascript">
import * as echarts from 'echarts';
export default {
   props:{
    list:{
      type: Array,
      default: [],
    }
   },
  data(){
    return {
      options: [
          {
            value: '01',
            label: '01月',
          },
          {
            value: '02',
            label: '02月',
          },
          {
            value: '03',
            label: '03月',
          },
          {
            value: '04',
            label: '04月',
          },
          {
            value: '05',
            label: '05月',
          },
          {
            value: '06',
            label: '06月',
          },
          {
            value: '07',
            label: '07月',
          },
          {
            value: '08',
            label: '08月',
          },
          {
            value: '09',
            label: '09月',
          },
          {
            value: '10',
            label: '10月',
          },
          {
            value: '11',
            label: '11月',
          },
          {
            value: '12',
            label: '12月',
          },
      ],
      value: this.$store.getters.currMonth,
      amount:0,
      tax:0,
      count:0
    }
  },
  mounted() {
  },
  created(){
  },
  methods:{
    init(list){
      this.$nextTick(() => {
        this.initChart(list)
      })
    },
    initChart(list){
      this.amount = '￥' + list.reduce((p,e)=>p+e.amount,0).toFixed(2);
      this.count = list.reduce((p,e)=>p+e.count,0) + '张';
      this.tax = '￥' + list.reduce((p,e)=>p+e.tax,0).toFixed(2);
      let data = list.map(v=>{return this.$fplx(v.fplxdm)+':'+ '￥'+v.amount.toFixed(2)})
      let seriesData = list.map(v=>{
        let amount = v.amount.toFixed(2)
        return {
          value: amount,
          name:this.$fplx(v.fplxdm) + ':'+ '￥' + amount
        }
      })
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('month'));
      // 绘制图表
      myChart.setOption({
        tooltip: {},
        legend: {
          orient: "horizontal",
          y: "bottom",
          data: data
        },
        series: [
          {
            type: 'pie',
            data: seriesData,
            radius: '40%'
          }
        ]
      });
      window.onresize = function(){
        myChart.resize()
      }
    },
    changeMonth(){
      this.$emit('success', this.value)
      console.log(this.value);
    }
  }
};
</script>
 
<style lang="less" scoped>
#main {
  height: 400px;
  width: 100%;
}
.content{
  color: gray;
  margin-bottom: 45px;
  margin-top: 12px;
}
.box{
  float: left;
  text-align: center;
  margin-left: 50px;
}
.countStyle{
  color: #6ABFBA;
  font-weight: 600;
}
</style>

<style>
.el-col.el-col-11.is-guttered{
  padding-left: 0px !important;
  padding-right: 0px !important;
  margin: 0 auto 0 auto
}
</style>